<p-toast position="top-right"></p-toast>
<p-confirmDialog #cd [style]="{width: '600px'}">
  <p-footer>
    <button type="button" pButton accesskey="d" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Remove" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

<div class="open-project-layout">
  <p-toolbar>
    <div class="p-toolbar-group-left">
      <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>
      <span style="padding-top:2px;">
        <button pButton type="button" 
                class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
                icon="pi pi-fw pi-refresh" 
                (click)="loadOpenProjects()"></button>

        <!-- Display only on bigger than md screens-->
        <span class="p-d-none p-d-md-inline">
          <button pButton type="button" *ngIf="canModifyOpenProject()" 
                  class="p-button p-button-text" 
                  label="Add Project" 
                  icon="pi-fw fas fa-plus-circle"
                  (click)="addOpenProject()"></button>

          <button (click)="exportOpenProject()"
                  [disabled]="exporting"
                  pButton type="button" 
                  class="p-button p-button-text"
                  label="Excel Report" 
                  icon="{{exporting ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fas fa-file-download'}}"></button>
        </span>

        <!-- Display only on smaller than md screens-->
        <span class="p-d-md-none">
          <button pButton type="button" *ngIf="canModifyOpenProject()" 
                  class="p-button-rounded"  
                  icon="pi-fw fas fa-plus-circle"
                  title="Add Project"
                  (click)="addOpenProject()"></button>
          <button (click)="exportOpenProject()"
                  pButton type="button" 
                  title="Export Excel Report"
                  class="p-button-rounded p-button-success"
                  icon="{{exporting ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fas fa-file-download'}}"></button>
        </span>

      </span>
    </div>

    <div class="p-toolbar-group-right">
      <i class="pi-fw far fa-bell p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon" pBadge 
         style="color: var(--green-600)" 
         severity="danger"
         pTooltip="Total Number of Open Projects: {{openProjects.length}}"
         value="{{openProjects.length}}"></i>
    </div>
  </p-toolbar>

  <div class="modal-body p-col-12 open-project-body">
    <div class="open-project-content" *ngIf="openProjects !== null && openProjects.length > 0">
      <div class="chart-container">
        <div class="chart-summary">
          <div class="summary-chip po">
            <span class="dot"></span>
            <span>Total PO: {{_util.formatCurrency(totalPoAmountSum)}}</span>
          </div>
          <div class="summary-chip invoice">
            <span class="dot"></span>
            <span>Total Invoice: {{_util.formatCurrency(totalInvoiceValueSum)}}</span>
          </div>
          <div class="summary-chip ipv">
            <span class="dot"></span>
            <span>Invoice Price Variance (IPV): {{_util.formatCurrency(totalPoAmountSum - totalInvoiceValueSum)}}</span>
          </div>
        </div>
        <div class="chart-plot">
          <p-chart #ipvChart
            type="bar"
            [data]="chartData"
            [options]="chartOptions"
            [plugins]="chartPlugins"
            [style]="{height: '100%'}">
          </p-chart>
        </div>
      </div>
      <ag-grid-angular
        #topGrid
        class="ag-theme-alpine open-project-grid"
        [loading]="loading"
        [localeText]="localeText"
        [context]="context"
        [rowData]="openProjects"
        [columnDefs]="gridHeaders"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }">
      </ag-grid-angular>
    </div>
    <p-messages [(value)]="messages"
                [closable]="false"
                [enableService]="false"
                *ngIf="openProjects !== null && openProjects.length === 0"></p-messages>
  </div>
</div>

